export class ChangeEmail {
  public id: string;
  public email: string;
}
